var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"users-table elevation-1",attrs:{"headers":_vm.headers,"items":_vm.onlineUsers,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.lastActivityDate",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("dateDMYT")(item.lastActivityDate)))])]}},{key:"item.companyId",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm._f("companyName")(item.companyId)))])]}},{key:"no-data",fn:function(){return [_vm._v(" NO ONLINE USERS ")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }